import React from "react";
import { useEffect } from "react";
function ProductdamageReturnpolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="product_damage_return_policy_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="inner-box">
              <h5>
                We will provide replacements in the following circumstances :
              </h5>
              <ul style={{ listStyleType: "circle" }}>
                <li>Genuine defect or damage in the product received</li>
                <li>Package damaged in transit</li>
                <li>In case wrong item has been shipped to you</li>
              </ul>
            </div>

            <div className="inner-box">
              <h5>No replacement will be given in the following cases :</h5>
              <ul style={{ listStyleType: "circle" }}>
                <li>Products returned in a used or damaged condition</li>
                <li>
                  If the customer changes his / her mind after purchasing or on
                  receipt of the product
                </li>
                <li>
                  If the product is returned without a written confirmation from
                  us via email
                </li>
                <li>
                  If the product is not returned through our courier,
                  professional courier & French express courier.
                </li>
              </ul>
            </div>

            <div className="inner-box">
              <h6>1) What to do in case the package is damaged?</h6>
              <p>
                In case the package appears damaged, crushed, wet or leaked from
                the outside please do not accept the package from the delivery
                person. It is probably damage-in-transit and should be not
                accepted from the courier company.However, if you discover the
                damage once you open the parcel, please report the damage to us
                within 48 hours of the delivery of the product through email
                (aammiisanthai@gmail.com) describing the damage as mentioned
                below along with images of the parcel.
              </p>
            </div>

            <div className="inner-box">
              <h6>2) What is the replacement process?</h6>
              <ul style={{ listStyleType: "number" }}>
                <li>
                  <p>
                    <b>Step 1 :</b> All eligible replacement requests need to be
                    notified to us by email toaammiisanthai@gmail.comwithin 48
                    hours of the delivery of the product. Please mention the
                    following information in the email :
                    <ul>
                      <li>Aammii Order Number</li>
                      <li>Your email ID registered with us</li>
                      <li>Name of the damaged product and quantity damaged</li>
                      <li>Description of the issue</li>
                      <li>
                        Clear photos of the package and the damaged products
                      </li>
                    </ul>
                  </p>
                </li>
                <li>
                  <p>
                    <b>Step 2 :</b> We will review your replacement request and
                    confirm if the request is approved on email in 48hours
                  </p>
                </li>
                <li>
                  <p>
                    <b>Step 3 :</b> If replacement is approved, we will arrange
                    to send replacement products (incase reason is not genuine
                    you will send damage product to us).
                  </p>
                </li>
                <li>
                  <p>
                    <b>Step 4 :</b> After the receipt of your parcel, we will
                    verify the products and authorize it for replacement within
                    7 working days if the products are found to be in proper
                    condition.
                  </p>
                </li>
                <li>
                  <p>
                    <b>Step 5 :</b> Once approved, we will ship the replacement
                    product in 7 working days. In case the replacement product
                    is not available in stock, we may contact you to choose a
                    different product or refund the purchase cost to you. The
                    refund process will take 7-10 working days.
                  </p>
                </li>
              </ul>
            </div>

            <div className="inner-box">
              <h6>3) When will I receive a replacement?</h6>
              <p>
                Replacement product will be shipped within 7 working days of the
                receipt of the original item, subject to the following
                conditions :
              </p>
              <ul style={{ listStyleType: "circle" }}>
                <li>The products should be unused, unsoiled and unwashed.</li>
                <li>
                  The products should have the original tags and should be in
                  the original packaging.
                </li>
                <li>
                  Any returned item received by us that does not meet the
                  above-mentioned conditions would not be accepted. No
                  replacement will be provided for such products.
                </li>
              </ul>
            </div>

            <div className="inner-box">
              <h6>4) Can I choose a different product in exchange?</h6>
              <p>No, you can't choose a different product in exchange.</p>
            </div>

            <div className="inner-box">
              <h6>5) How much time does it take to issue the refund?</h6>
              <p>
                The refund process will take 7-10 working days from the receipt
                of the returned goods.
              </p>
            </div>

            <div className="inner-box">
              <h6>6) How is the refund made?</h6>
              <p>
                Refund will be sent to the same card/bank account from which the
                payment was made. In case it is not possible for our Payment
                Gateway to send the refund to the same card/bank account due to
                the expiry of the refund window, we will request you to provide
                bank details of yours using which we will send the refund money
                through bank transfer.
              </p>
            </div>

            <div className="inner-box">
              <h6>7) Can I modify or cancel my order?</h6>
              <p>
                No, you can't modify or cancel an order once placed successfully
                on the website.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProductdamageReturnpolicy;
